import { Fragment, h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import Feedback from '../../../../common/hoc/feedback';
import { useStyles } from '../../../../common/hooks';
import { Icon } from '../../common/svg/icons';
import {
  FEEDBACK_STYLE_TEXT_TRACK,
  TEXT_TRACK_TEXT_DETAIL_STYLE,
  TEXT_TRACK_TEXT_FEEDBACK_STYLE
} from './styles';

const TIME_DELAY_FOR_SETTINGS_APPLIED = 2000;

function TrackFeedBack({
  trackSelected,
  track = { index: -1 },
  type,
  defaultIndex = -1
}) {
  const [visible, setVisible] = useState(false);
  const prevLangRef = useRef(trackSelected);
  const isTrackSettingsApplied = useRef(false);

  useEffect(() => {
    // Handle initial delay because audo|text is changed automatically in settings
    const delayTimer = setTimeout(() => {
      isTrackSettingsApplied.current = true;
    }, TIME_DELAY_FOR_SETTINGS_APPLIED);
    return () => clearTimeout(delayTimer);
  }, []);

  useEffect(() => {
    if (trackSelected !== prevLangRef.current) {
      if (isTrackSettingsApplied.current) {
        setVisible(true);
      }
      prevLangRef.current = trackSelected;
    }
  }, [trackSelected]);
  const text1Style = useStyles()(TEXT_TRACK_TEXT_FEEDBACK_STYLE);
  const text2Style = useStyles()(TEXT_TRACK_TEXT_DETAIL_STYLE);
  const wrapperStyle = useStyles()(FEEDBACK_STYLE_TEXT_TRACK);

  const content = track.index === defaultIndex
    ? (
      <div>
        {`${type} désactivés`}
      </div>
    )
    : (
      <Fragment>
        <div>
          {`${type} activés (`}
        </div>
        <div>{track.label.toLowerCase()}</div>
        {track?.icon && (
          <Icon
            name={track?.icon}
            width={text1Style.iconSize}
            height={text1Style.iconSize}
          />
        )}
        <div>)</div>
      </Fragment>
    );

  return visible && (
    <Feedback
      onClose={() => setVisible(false)}
      visible={visible}
      key="feedback-track"
      style={wrapperStyle}
    >
      <div style={text1Style}>{content}</div>
      <div style={text2Style}>
        <div>{'Cliquer sur '}</div>
        <Icon
          name="settings"
          width={text2Style.iconSize}
          height={text2Style.iconSize}
        />
        <div>
          {' pour personnaliser'}
        </div>
      </div>
    </Feedback>
  );
}

export default TrackFeedBack;
